
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Extra Curricular Events</h1>
                </div>
            </div>
        </div>			
    </div>	
</section>  

<section class="section-lg std-scholarship">
    <div class="container">
      <div class="row justify-content-start row-50">
        <!-- <div class="col-md-9">
          <div class="inner-title"  >
            <h3>Upcoming Event</h3>							
           
          </div> 
          <h5>GH Raisoni College of Commerce Science and Technology is organising Bigg Boss Season 5 for the new batch of BBA and BCCA. From uncensored fights to uncut actions…Watch Bigg Boss Season 5 live on 13<sup>th</sup> November, 2021 ..9 am onwards.--</h5>          
           <h4 class="text-center mt-3"><a href="https://youtu.be/2b80CmU-lYI" target="_blank"> Go to Link :https://youtu.be/2b80CmU-lYI</a></h4>
        </div>
        <div class="col-md-3">
          <div class="text-center">
            <div class="gallery-item" data-aos="zoom-in-down">
              <a href="assets/images/big-boss.jpg" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                  <img class="img-fluid" src="assets/images/big-boss.jpg" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                  <div class="gallery-overlay"><h6>Fresher’s party"</h6>	</div>
              </a>
            </div>
          </div>
        </div> -->
      </div>          
        <div class="row row-50 mt-4">
            <div class="col-md-12">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-row" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Induction (Aarambh)</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Cultural cell</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Literature</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Creative</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Fitness</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">Sahas – Adventure Camp</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7" aria-selected="false">Rotaract</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab8-tab" data-toggle="tab" href="#tab8" role="tab" aria-controls="tab8" aria-selected="false">NSS</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab9-tab" data-toggle="tab" href="#tab9" role="tab" aria-controls="tab9" aria-selected="false">Nature</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab10-tab" data-toggle="tab" href="#tab10" role="tab" aria-controls="tab10" aria-selected="false">Saraswati Pooja</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab11-tab" data-toggle="tab" href="#tab11" role="tab" aria-controls="tab11" aria-selected="false">Excursion</a>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" id="tab12-tab" data-toggle="tab" href="#tab12" role="tab" aria-controls="tab12" aria-selected="false">Big Boss</a>
                        </li> -->
                    </ul>
                </div>
            </div>
            <div class="col-md-12">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Induction (Aarambh)</h3>							
                           
                        </div>                        
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/arambh-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/arambh-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/arambh-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/arambh-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/arambh-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/arambh-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/arambh-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/arambh-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/arambh-5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/arambh-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/arambh-6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/arambh-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/Induction_Program.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/mng_fest-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6 class="text-center">Aarambh Induction</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Cultural cell
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/freshers-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/freshers-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fresher’s party"</h6>	</div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/freshers-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/freshers-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fresher’s party"</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/freshers-3.webp"  data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/freshers-3.webp"  alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fresher’s party"</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/indradhanu.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/indradhanu.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Indradhanu</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/deep_ramzan-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/deep_ramzan-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Deep Ramzan</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/deep_ramzan-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/deep_ramzan-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Deep Ramzan</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/farewell-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/farewell-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Farewell Party</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/farewell-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/farewell-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Farewell Party</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/farewell-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/farewell-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Farewell Party</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/farewell-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/farewell-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Farewell Party</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>                          
                    </div>

                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                        <div class="inner-title"  >
                            <h3>Literature
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/lit-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/lit-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Club Installation</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/lit-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/lit-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Story writing Competition</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/lit-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/lit-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Poetry writing Competition</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/lit-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/lit-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Slogan writing Competition</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                        <div class="inner-title"  >
                            <h3>Creative
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/creative_club-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/creative_club-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Creative Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/creative_club-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/creative_club-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Creative Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/creative_club-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/creative_club-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Creative Club</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
                        <div class="inner-title"  >
                            <h3>Fitness
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/fitness-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/fitness-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fitness Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/fitness-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/fitness-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fitness Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/fitness-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/fitness-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fitness Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/fitness-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/fitness-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Fitness Club</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
                        <div class="inner-title"  >
                            <h3>Sahas – Adventure Camp
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-7.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-7.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-8.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-8.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-9.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-9.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-10.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-10.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sahas-11.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sahas-11.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sahas – Adventure Camp</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
                        <div class="inner-title"  >
                            <h3>Rotaract
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/rota_beti.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/rota_beti.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Rotaract Beti Bachao Bati Padhao Mission</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/rota_blood.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/rota_blood.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Rotaract  Blood Donation Camp</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/rota_ganpati.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/rota_ganpati.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Rotaract Ganpati Visarjan Nirmalya Program</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/rota_hcl.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/rota_hcl.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Rotaract HCL Marathon Meadal Ceremony</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/rota_police.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/rota_police.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Rotaract  Police Day</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab8" role="tabpanel" aria-labelledby="tab8-tab">
                        <div class="inner-title"  >
                            <h3>NSS
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nss_ny.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nss_ny.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>National Youth Day</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nss_rp_d.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nss_rp_d.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Republic Day</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nss_sdt.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nss_sdt.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Self Defence</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nss_tb.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nss_tb.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>TB Awareness</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nss_siss.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nss_siss.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Sports Interaction with Slum Soccer Scotland Team</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab9" role="tabpanel" aria-labelledby="tab9-tab">
                        <div class="inner-title"  >
                            <h3>Natures Club
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nature1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nature1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Natures Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nature2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nature2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Natures Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nature3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nature3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Natures Club</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/nature4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/nature4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Natures Club</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab10" role="tabpanel" aria-labelledby="tab10-tab">
                        <div class="inner-title"  >
                            <h3>Saraswati Pooja
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/sarswati-7.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/sarswati-7.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>Saraswati Pooja</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab11" role="tabpanel" aria-labelledby="tab11-tab">
                        <div class="inner-title"  >
                            <h3>Excursion
                            </h3>
                           
                        </div>
                        <div class="row mb-20">
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/excursion-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/excursion-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>International Tour</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/excursion-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/excursion-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>National Tour</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/excursion-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/excursion-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>International Tour</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/excursion-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/excursion-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>International Tour</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/excursion-5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/excursion-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>National Tour</h6></div>
                                </a>
                              </div>
                            </div>
                            <div class="col-md-3 col-6">
                              <div class="gallery-item" data-aos="zoom-in-down">
                                <a href="assets/images/gallery/excursion-6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                                    <img class="img-fluid" src="assets/images/gallery/excursion-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                                    <div class="gallery-overlay"><h6>National Tour</h6></div>
                                </a>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>